import { useContext } from "react";
import useSWR from "swr";
import { InvoiceDetailsModel, InvoiceTotalInfoModel } from "../models/ChasableModels";
import { ContactModel } from "../models/ContactModels";
import { PaymentDetailsModel } from "../models/PaymentModels";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

type SupplierDetails = ContactModel & { invoices: InvoiceDetailsModel[] } & {
  payments: PaymentDetailsModel[];
} & InvoiceTotalInfoModel;

export const useSupplier = (supplierId: string | null | undefined) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<SupplierDetails>(
    supplierId ? `${environment.apiUrl}/api/contacts/suppliers/${supplierId}` : null,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("The supplier details failed to load, please try again later", "error");
      },
    }
  );

  return {
    supplier: data,
    isLoading,
    isError: !!error,
  };
};
